import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  GestureConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material';

import { rootRouterConfig } from './app.routing';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// custom services
import { ApiEndpoints } from './shared/services/api-endpoints.service';
import { LoginService } from './shared/services/login.service';
import { Broadcaster } from './shared/services/broadcaster.service';
import { CookieService } from 'ngx-cookie-service';
import { JwtDecoder } from './shared/services/auth/jwt-decoder.service';
import { LeadProfileData } from './views/profile/profile-settings/profile-data.service';
import { Log } from 'ng2-logger/client';
import { StorageService } from './shared/services/auth/storage.service';
import { MailSettingsModule } from './views/mail-settings/mail-settings.module';
// import { WelcomePopupComponent } from './views/welcome-popup/welcome-popup.component';
import { NoAccessPopup } from './views/contacts/no-access-popup/no-access-popup.component';

import {
  MatSidenavModule,
  MatInputModule,
  MatIconModule,
  MatCardModule,
  MatMenuModule,
  MatButtonModule,
  MatChipsModule,
  MatListModule,
  MatTooltipModule,
  MatDialogModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatSelectModule,
} from '@angular/material';
import { FinderModule } from './views/property-finder/property-finder.module';
import { IonRangeSliderModule } from 'ng2-ion-range-slider';
import { AgmCoreModule } from '@agm/core';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    FinderModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(rootRouterConfig, { useHash: false }),
    IonRangeSliderModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDt9U0GJGEi9MI5bpcRuWJIeN04J58CHsM',
    }),
  ],
  declarations: [AppComponent, NoAccessPopup],
  providers: [
    // ANGULAR MATERIAL SLIDER FIX
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    ApiEndpoints,
    Broadcaster,
    CookieService,
    JwtDecoder,
    LeadProfileData,
    Log,
    StorageService,
    LoginService,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ],
  bootstrap: [AppComponent],
  entryComponents: [NoAccessPopup],
})
export class AppModule {}
